import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSevereIrritationSelectedEmojiSecondary from './svgs/SevereIrritationSelectedEmojiSecondary.js';
import SvgSevereIrritationSelectedEmoji from './svgs/SevereIrritationSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var severeIrritationSelectedEmoji = (props => useIcon(SvgSevereIrritationSelectedEmoji, SvgSevereIrritationSelectedEmojiSecondary, props));

export { severeIrritationSelectedEmoji as default };
